var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am2-category-tabs"},_vm._l((_vm.items),function(item){return _c('div',{key:item.key,class:[
      'category',
      _vm.realVal == item.key && 'active'
    ],attrs:{"data-test-id":item.text},on:{"click":function($event){return _vm.handleCategoryClick(item.key)}}},[_c('ar-text',{style:({
        color: _vm.realVal == item.key ? 'white' : _vm.$arStyle.color.skyBlueGrey700,
      }),attrs:{"size":"xs","text":item.text}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }